import asyncComponent from '../component/asyncComponent'

export default [
    {
        name: "SelfRecommendation",
        route: "/SelfRecommendation/:communityId/:phone",
        component: asyncComponent(() => import('../pages/SelfRecommendation')),
    },
    {
        name: "SelfRecommendationSubmit",
        route: "/SelfRecommendationSubmit/:communityId/:pollId/:isApp",
        component: asyncComponent(() => import('../pages/SelfRecommendationSubmit')),
    },
    {
        name: "SelfRecommendationRecord",
        route: "/selfRecommendationRecord/:pollId/:phone",
        component: asyncComponent(() => import('../pages/SelfRecommendationRecord')),
    },
    {
        title: "业委会成立",
        name: "committeeSetup",
        route: "/CommitteeSetup",
        component: asyncComponent(() => import('../pages/committeeSetup')),
    },
    {
        title: "业委会成立流程图",
        name: "committeeSetupProcess",
        route: "/CommitteeSetupProcess",
        component: asyncComponent(() => import('../pages/committeeSetupProcess')),
    },
    {
        title: "业委会成立自荐",
        name: "SelfRecommendationForm",
        route: "/SelfRecommendationForm/:communityId/:phone",
        component: asyncComponent(() => import('../pages/SelfRecommendationForm')),
    },
    {
        name: "SelfRecommendationSubmitForm",
        route: "/SelfRecommendationSubmitForm/:communityId/:isApp",
        component: asyncComponent(() => import('../pages/SelfRecommendationSubmitForm')),
    },
    {
        name: "SelfRecommendationRecordForm",
        route: "/SelfRecommendationRecordForm/:communityId/:phone",
        component: asyncComponent(() => import('../pages/SelfRecommendationRecordForm')),
    },
    {
        title: "业主投票详情",
        name: "Voting",
        route: "/voting/:communityId/:phone/:pollId",
        component: asyncComponent(() => import('../pages/Voting')),
    },
    {
        title: "业主投票分享",
        name: "shareVoting",
        route: "/shareVoting/:communityId/:pollId",
        component: asyncComponent(() => import('../pages/shareVoting')),
    },
    {
        title: "业主投票列表",
        name: "pollList",
        route: "/PollList/:communityId/:phone",
        component: asyncComponent(() => import('../pages/pollList')),
    },
    {   
        title: "业委会换届流程图",
        name: "Election",
        route: "/election",
        component: asyncComponent(() => import('../pages/Election')),
    },
    {
        title: "业委会换届",
        name: "ChangeOwersHome",
        route: "/changeOwersHome",
        component: asyncComponent(() => import('../pages/ChangeOwersHome')),
    },
]